import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import TopTabbar from "../components/partials/TopTabbar";
import Header from "../components/partials/Header";
import Footer from "../components/partials/Footer";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import RecipientFormModal from '../components/modals/recipient/RecipientFormModal';
import RecipientDetailModal from '../components/modals/recipient/RecipientDetailModal';
import RecipientService from '../services/RecipientService';
import Swal from 'sweetalert2';
import AuthService from '../services/AuthService';
import LoadingSpinner from '../utils/LoadingSpinner';

const allowedCountries = ['Cameroun', "Côte d'Ivoire", 'Bénin', 'Burkina Faso', 'Sénégal'];

const RecipientPage = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [recipients, setRecipients] = useState([]);
    const [filteredRecipients, setFilteredRecipients] = useState([]);
    const [selectedRecipient, setSelectedRecipient] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('Tous les pays');
    const [isPageLoading, setIsPageLoading] = useState(true);

    useEffect(() => {
        fetchRecipients();
    }, []);

    const fetchRecipients = async () => {
        try {
            const currentUser = AuthService.getCurrentUser();
            if (!currentUser) {
                toast.error('Utilisateur non connecté.');
                return;
            }
            const data = await RecipientService.getAllRecipients();
            const userRecipients = data.filter(recipient => recipient.createdBy === currentUser.username);
            setRecipients(userRecipients);
            setFilteredRecipients(userRecipients);
        } catch (error) {
            toast.error('Erreur lors de la récupération des destinataires.');
        } finally {
            setIsPageLoading(false);
        }
    };

    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);
    const handleCloseDetailModal = () => setShowDetailModal(false);
    const handleShowDetailModal = (recipient) => {
        setSelectedRecipient(recipient);
        setShowDetailModal(true);
    };

    const handleDeleteRecipient = async (id) => {
        const result = await Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Vous ne pourrez pas revenir en arrière!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        });
        if (result.isConfirmed) {
            try {
                await RecipientService.deleteRecipient(id);
                toast.success('Destinataire supprimé avec succès!');
                fetchRecipients();
            } catch (error) {
                toast.error('Erreur lors de la suppression du destinataire.');
            }
        }
    };

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        filterRecipients(term, selectedCountry);
    };

    const handleFilter = (country) => {
        setSelectedCountry(country);
        filterRecipients(searchTerm, country);
    };

    const filterRecipients = (term, country) => {
        const filtered = recipients.filter(recipient => {
            const matchesSearch = recipient.firstName.toLowerCase().includes(term.toLowerCase()) ||
                recipient.lastName.toLowerCase().includes(term.toLowerCase()) ||
                recipient.email.toLowerCase().includes(term.toLowerCase());
            const matchesCountry = country === 'Tous les pays' || recipient.country === country;
            return matchesSearch && matchesCountry;
        });
        setFilteredRecipients(filtered);
    };

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des destinataires..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />
                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="form-actions mb-3 mt-32" style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        paddingTop: '50px',
                                    }}>
                                        <div className="header-title mt-32">
                                            <p style={{ fontSize: '25px' }}>Mes Destinataires</p>
                                        </div>
                                        <button
                                            className="btn btn-success mt-32"
                                            onClick={handleShowModal}
                                        >
                                            <i className="fas fa-plus me-2"></i> Ajouter un destinataire
                                        </button>
                                    </div>
                                    <div className="contact-search">
                                        <div className="input-group contact-searchbar">
                                            <div className="search-icon">
                                                <img src="assets/svg/search-icon.svg" alt="search-icon" />
                                            </div>
                                            <div className="seach-bar">
                                                <input
                                                    type="search"
                                                    placeholder="Rechercher un destinataire"
                                                    className="form-control search-text"
                                                    id="search-input"
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="verify-number-bottom" id="bank-and-card-main">
                                <div className="container mb-35">
                                    <div className="nav nav-tabs custom-tab-contact" role="tablist">
                                        <button
                                            className={`nav-link ${selectedCountry === "Tous les pays" ? "active" : ""}`}
                                            onClick={() => handleFilter("Tous les pays")}
                                        >
                                            Tous les pays
                                        </button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="link" className="nav-link dropdown-toggle">
                                                <i className="fas fa-filter me-2"></i>
                                                Filtrer
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {allowedCountries.map((country) => (
                                                    <Dropdown.Item
                                                        key={country}
                                                        onClick={() => handleFilter(country)}
                                                    >
                                                        {country}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="container mt-5">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="transfer-to-bank">
                                                {filteredRecipients.length > 0 ? (
                                                    filteredRecipients.map(recipient => (
                                                        <div key={recipient.id} className="d-flex align-items-center p-3 mb-3 rounded shadow-sm">
                                                            <div
                                                                className="me-3 cursor-pointer"
                                                                onClick={() => handleShowDetailModal(recipient)}
                                                            >
                                                                <img
                                                                    src="assets/images/invite-friend/avatar.jpg"
                                                                    alt="profile"
                                                                    className="rounded-circle"
                                                                    style={{ width: '80px', height: '80px' }}
                                                                />
                                                            </div>
                                                            <div
                                                                className="flex-grow-1 overflow-hidden me-3 cursor-pointer"
                                                                onClick={() => handleShowDetailModal(recipient)}
                                                            >
                                                                <h5 className="text-truncate mb-1">
                                                                    {recipient.firstName} {recipient.lastName}
                                                                </h5>
                                                                <p className="text-truncate text-muted mb-1">
                                                                    {recipient.email}
                                                                </p>
                                                                <p className="text-truncate text-muted mb-0">
                                                                    {recipient.country}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    onClick={() => handleDeleteRecipient(recipient.id)}
                                                                    className="btn btn-link text-danger p-0 cursor-pointer"
                                                                >
                                                                    <i className="fas fa-trash-alt fa-lg"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center py-5">
                                                        <img
                                                            src="assets/images/setting/no_data.png"
                                                            alt="Aucun transfert"
                                                            className="img-fluid mb-4"
                                                            style={{ maxWidth: '100px' }}
                                                        />
                                                        <p className="text-muted fs-5 mb-4">Aucun destinataire trouvé</p>
                                                        <Button variant="primary" onClick={handleShowModal}>
                                                            Ajouter
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                            <RecipientFormModal
                                show={showModal}
                                handleClose={handleCloseModal}
                                onDataReload={fetchRecipients}
                            />
                            <RecipientDetailModal
                                show={showDetailModal}
                                handleClose={handleCloseDetailModal}
                                recipient={selectedRecipient}
                                onUpdate={fetchRecipients}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecipientPage;
